import { getApi } from 'apis';
import dayjs from 'dayjs';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toastText } from 'utils/utils';
import AddSalaryModal from './AddSalary';
import SalaryHeader from './Header';
import SalaryTable from './SalaryTable';

type Props = {
	employeeId: string;
	setIsEmployeeSalaryExists: (value: boolean) => void;
	isViewMode?: boolean;
	isUsd?: boolean;
};
const SalaryDetails = (props: Props) => {
	const {
		employeeId,
		setIsEmployeeSalaryExists,
		isViewMode = false,
		isUsd,
	} = props;

	const [isAddSalaryModalOpen, setIsAddSalaryModalOpen] = useState(false);

	const [selectedYear, setSelectedYear] = useState<any>(dayjs());
	const [salaryData, setSalaryData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalRecords, setTotalRecords] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [searchParams] = useSearchParams();

	const buttons = [
		{
			text: 'Add Salary',
			isLoading: false,
			className: 'btn-blue',
			disabled: isLoading,
			// icon: <AddSvg />,
			isSubmit: true,
			onclick: () => {
				setIsAddSalaryModalOpen(true);
			},
		},
	];

	const handleCancel = () => {
		setIsAddSalaryModalOpen(false); // Close the modal
	};
	const refreshSalary = () => {
		setCurrentPage(1);
		fetchSalary();
	};
	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const fetchSalary = async () => {
		try {
			// Extract employeeId from searchParams
			const employeeId = searchParams.get('employeeId');
			setIsLoading(true);
			const query = {
				employeeId: employeeId,
				page: currentPage,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
				id: employeeId,
				year: selectedYear['$y'],
			};
			if (isViewMode) {
				delete query.year;
			}
			const salaries = await getApi('/employee/detailed-salary', query);
			setSalaryData(salaries.data.data);
			setTotalRecords(salaries.data.count);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching salaries';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (searchParams.get('employeeId')) {
			fetchSalary();
		}
	}, [pageSize, currentPage, sortOrder, sortField, selectedYear]);

	return (
		<div>
			{!isViewMode && (
				<SalaryHeader
					button={buttons}
					changeYear={(value: string) => setSelectedYear(value)}
					selectedYear={selectedYear}
					fetchSalary={refreshSalary}
					isLoading={isLoading}
				/>
			)}
			<div>
				<SalaryTable
					salaryData={salaryData}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
					tableChangeHandler={tableChangeHandler}
					isLoading={isLoading}
					isUSD={isUsd}
				/>
			</div>
			{!isViewMode && (
				<AddSalaryModal
					isAddSalaryModalOpen={isAddSalaryModalOpen}
					handleCancel={handleCancel}
					employeeId={employeeId}
					fetchSalary={fetchSalary}
					setIsEmployeeSalaryExists={setIsEmployeeSalaryExists}
					isUSD={isUsd}
				/>
			)}
		</div>
	);
};

export default SalaryDetails;
